export default "__VITE_ASSET__C3qLE0MU__"